"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-four/sections/videoSection.tsx */

import { SmartLink } from "@/Components";
import Lightbox, { type LightboxSlide } from "../../Components/Lightbox";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, ReactNode, CSSProperties } from "react";

export type HomeFourVideoSectionGeneratedProps = {
    lightboxSlides?: LightboxSlide[];
    lightboxOpen?: boolean;
    lightboxIndex?: number;
    onLightboxClose?: () => void;
    onLightboxView?: (index: number) => void;
    onOpenLightbox?: (index: number) => void;
    motionSectionStyle?: CSSProperties;
    /** Default: "" */
    motionSectionDiv0Div0Link0LinkDataFancybox?: string;
    /** Default: "#" */
    motionSectionDiv0Div0Link0LinkHref?: string;
    /** Default: "Play" */
    motionSectionDiv0Div0Link0LinkText?: ReactNode;
    motionSectionDiv0Div0Link0LinkVisible?: boolean;
    motionSectionDiv0Div0Link0LinkRenderer?: (defaultNode: ReactNode) => ReactNode;
    motionSectionDiv0Div0Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>>;
};

const HomeFourVideoSectionGenerated: FC<HomeFourVideoSectionGeneratedProps> = ({
    lightboxSlides = [],
    lightboxOpen,
    lightboxIndex,
    onLightboxClose,
    onLightboxView,
    onOpenLightbox,
    motionSectionDiv0Div0Link0LinkDataFancybox = "",
    motionSectionDiv0Div0Link0LinkHref = "#",
    motionSectionDiv0Div0Link0LinkText = "Play",
    motionSectionDiv0Div0Link0LinkVisible,
    motionSectionDiv0Div0Link0LinkRenderer,
    motionSectionDiv0Div0Link0LinkProps,
    motionSectionStyle,
}) => {
    return (
        <>
            <div style={motionSectionStyle} className="video-section mx-auto section" data-template-tag="motion.section">
                <div className="container">
                    <div className="video-content">
                        {renderNode(motionSectionDiv0Div0Link0LinkVisible, motionSectionDiv0Div0Link0LinkRenderer, (
                            <SmartLink href={motionSectionDiv0Div0Link0LinkHref} className="video-icon" data-fancybox={motionSectionDiv0Div0Link0LinkDataFancybox} {...(motionSectionDiv0Div0Link0LinkProps ?? {})}>
                                <i className="isax isax-play" />
                                {motionSectionDiv0Div0Link0LinkText}
                            </SmartLink>
                        ))}
                    </div>
                </div>
            </div>
            <Lightbox images={lightboxSlides} currentIndex={lightboxIndex ?? 0} isOpen={lightboxOpen} onClose={() => onLightboxClose?.()} onNavigate={(index) => onLightboxView?.(index)} />
        </>
    );
};

export default HomeFourVideoSectionGenerated;
